import { render, staticRenderFns } from "./tree-ebk-div.vue?vue&type=template&id=2c7adce2&scoped=true&"
import script from "./tree-ebk-div.vue?vue&type=script&lang=ts&"
export * from "./tree-ebk-div.vue?vue&type=script&lang=ts&"
import style0 from "./tree-ebk-div.vue?vue&type=style&index=0&id=2c7adce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7adce2",
  null
  
)

export default component.exports